/**
 * String timestamp-ból készít dátumot
 */
export default function (app) {
	app.directive('stringTimestampToDate', function () {
		return {
			scope: {
				timestamp: '@'
			},
			restrict: 'A',
			link: function (scope, elem, attrs) {
				attrs.$observe('timestamp', function (value) {
					var intTimestamp = parseInt(value, 10);

					if (scope.timestamp.length == 10) {
						intTimestamp *= 1000;
					}
					scope.timestampPreDate = intTimestamp;
				});

			},
			template: '{{timestampPreDate | date}}'
		};
	});
};
